<template>
  <div class="signup-form-wrapper border">
    <h3>Sign In</h3>
    <form class="signup-form">
      <div class="input-grp">
        <label class="block-label" for="email">Email</label>
        <input type="text" />
      </div>
      <div class="input-grp">
        <label class="block-label" for="password">Password</label>
        <input type="password" />
      </div>
      <button type="submit">Submit</button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Grid1x1',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.signup-form-wrapper {
  box-sizing:border-box;
  display: grid;
  min-height:100px;
  max-width:700px;
  grid-template-columns: 1fr;
  text-align:center;
  padding:1em;
}
.input-grp {
  text-align:left;
}
.block-label {
  display:block;
}
.border {
  border: 1px dashed navy;
}
</style>
